if (!customElements.get("collection-load-more")) {
  class CollectionLoadMore extends HTMLElement {
    constructor() {
      super();

      // Configurations
      this.loadMoreButton = this.querySelector("#paginate-next");
      this.products_on_page = document.getElementById("product-grid");
      this.loadMoreSpinner = this.querySelector(".loading__spinner");

      this.loadMoreProducts = this.loadMoreProducts.bind(this);

      document.addEventListener("change", (event) => {
        this.initCollectionLoadMore();
      });
    }

    connectedCallback() {
      this.initCollectionLoadMore();
    }

    initCollectionLoadMore() {
      if (!this.loadMoreButton) return;
      document.addEventListener("click", this.loadMoreProducts, false);
    }

    async getNextPage(next_url) {
      try {
        let res = await fetch(next_url);
        return await res.text();
      } catch (error) {
        console.log(error);
      }
    }

    async loadMoreProducts(e) {
      const paginateButton = e.target.closest("#paginate-next");
      if (!paginateButton) return;

      paginateButton.disabled = true;
      paginateButton.querySelector(".loading__spinner").classList.remove("hidden");

      let nextPage = await this.getNextPage(paginateButton.dataset.href);
      const parser = new DOMParser();
      const nextPageDoc = parser.parseFromString(nextPage, "text/html");
      const productGrid = nextPageDoc.getElementById("product-grid");
      const newProducts = productGrid.querySelectorAll(".product-grid__item");
      const newUrl = nextPageDoc.getElementById("paginate-next");

      if (newUrl.dataset.href.length > 0) {
        paginateButton.dataset.href = newUrl.dataset.href;
        paginateButton.innerHTML = newUrl.innerHTML;
        paginateButton.querySelector(".loading__spinner").classList.add("hidden");
        paginateButton.disabled = false;
      } else {
        paginateButton.classList.add("hidden");
      }
      for (let i = 0; i < newProducts.length; i++) {
        this.products_on_page.appendChild(newProducts[i]);
      }
    }
  }

  customElements.define("collection-load-more", CollectionLoadMore);
}
